import '@fortawesome/fontawesome-svg-core/styles.css'
import 'react-datepicker/dist/react-datepicker.css'

import { PrinterIcon } from '@heroicons/react/outline'
import { useEffect, useState } from 'react'
import { ExtractItem } from '../../utils/extractDescription'
import {
  Action,
  ArrowPageLeftIcon,
  ArrowPageRightIcon,
  ButtonRecharger,
  ButtonWrapper,
  Container,
  Content,
  ContentWrapper,
  PaginationWrapper,
  PrintButtonIcon,
  Search,
  TableWrapper,
} from './styles'

import pt from 'date-fns/locale/pt'
import { registerLocale } from 'react-datepicker'
import { useNavigate } from 'react-router-dom'
import {
  ModalClose,
  ModalContainer,
  ModalContent,
  ModalRoot,
} from 'src/components/ui/modal'
import { useQrCodeDynamicStepForm } from 'src/context/qrcodeDynamicContext'
import { Skeleton } from '../../components/skeleton'
import { service as api } from '../../services/ajio'
import { currencyFormat } from '../../utils/currencyFormat'
import { dateFormatDaily } from '../../utils/dateFormat'
import { SelectValueStatic } from '../newQrCode/components/selectValueStatic'

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ')
}

registerLocale('pt', pt)

export interface Transaction {
  id: string
  description: string
  balanceAfter: number
  date: string
  status: string
  credit: boolean
  data: any
  GraphicAccount: boolean
  createdAt: string
  category: string
  amount: string
  type: string
  transactionData: {
    clientNamePayer: string
    clientName: string
    keyTarget: string
  }
}

export interface Detail {
  id: string
  credit: boolean
  amount: number
  description: string
  rateValue: number
  consignorName: string
  consignorDocument: string
  consignorBankNumber: string
  consignorBankBranch: string
  consignorBankAccount: string
  consignorBankAccountDigit: string
  beneficiaryName: string
  beneficiaryDocument: string
  beneficiaryBankNumber: string
  beneficiaryBankBranch: string
  beneficiaryBankAccount: string
  beneficiaryBankAccountDigit: string
  status: string
  date: string
}

export interface ShowTransaction {
  category: string
  transactionData: any
  detail: any
  transaction: any
  createdAt: string
  amount: string
}

export const AddWalletFounds = () => {
  const [loading, setLoading] = useState(true)
  const [items, setItems] = useState<ExtractItem[]>([])
  const [currentPage, setCurrentPage] = useState(1)
  const navigate = useNavigate()
  const { formDynamicStep, formDynamicData, prevStepDynamic } =
    useQrCodeDynamicStepForm()
  const [isOpen, setIsOpen] = useState(false)

  const user = JSON.parse(localStorage.getItem('@stricv2:user') as string)
  useEffect(() => {
    setLoading(true)

    api
      .get(`/transactions`, {
        params: {
          page: currentPage,
        },
      })
      .then(({ data }) => {
        const transactions = data.transactions.data.filter(
          (item: any) => item.type === 'PIX_DYNAMIC'
        )

        setItems(transactions)
        setLoading(false)
      })
  }, [currentPage])

  useEffect(() => {
    if (user.role !== 'WALLET') {
      navigate('/wallet/balancete')
    }
  }, [user, navigate])

  const handleCloseDynamicModal = () => {
    prevStepDynamic()
  }

  function closeModal() {
    setIsOpen(false)
  }

  function handlePrevious() {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1)
    }
  }

  function handleNext() {
    setCurrentPage(currentPage + 1)
  }

  const [openBalanceDialog, setOpenBalanceDialog] = useState(false)

  const handleOpenBalanceDialog = () => {
    setOpenBalanceDialog(true)
  }

  const handleCloseBalanceDialog = () => {
    setOpenBalanceDialog(false)
  }

  function printPDF(data: ExtractItem) {
    if (!data) return null

    const receiptString = JSON.stringify(data)

    localStorage.setItem('temp_receipt_to_print', receiptString)

    navigate('/PDF')
  }

  console.log(items)

  return (
    <>
      {/* <ModalConfirmOperation
				closeModal={closeModal}
				modalIsOpen={modalIsOpen}
				afterOpenModal={afterOpenModal}
			/> */}
      <Container className="w-full">
        <Content className="w-full h-full padding-container items-center justify-center">
          <ContentWrapper className="w-full">
            <Action className="items-center justify-center">
              <Search>
                <span className="p-texte">
                  Acompanhe por aqui seu histórico de recargas, realize seus
                  depósitos por aqui. Você também pode acessar o extrato deles
                  clicando em detalhes.
                </span>
              </Search>
              <ButtonWrapper className="flex items-center gap-2">
                <ButtonRecharger
                  className="border-radius-container w-[180px] py-[3%] mb-4"
                  onClick={() => setIsOpen(true)}
                >
                  Adicionar Saldo
                </ButtonRecharger>
                <ButtonRecharger
                  className="border-radius-container w-[180px] py-[3%] mb-4"
                  onClick={() => navigate('/paybills/invoice')}
                >
                  Pagar Conta
                </ButtonRecharger>
              </ButtonWrapper>
            </Action>
            {loading ? (
              <div className="height-skeleton bg-[#FFFFFF] w-full items-center justify-center mx-auto">
                <Skeleton space={3} isActive={loading} repeat={5} />
              </div>
            ) : (
              <div className="w-full">
                <TableWrapper className="w-full">
                  {!loading && items.length <= 0 && (
                    <div className="p-6">
                      <div className="text-center">
                        <h3 className="mt-2 text-sm font-medium text-gray-900">
                          Nenhum lançamento para o período selecionado
                        </h3>
                        <p className="mt-1 text-sm text-gray-500">
                          Selecione outro período ou faça uma transferência e
                          comece a usar agora mesmo
                        </p>
                      </div>
                    </div>
                  )}
                  <table className="w-full border-collapse">
                    <thead>
                      {!loading && items.length > 0 && (
                        <tr>
                          <th className="table-title">Data</th>
                          <th className="table-title">Tipo</th>
                          <th className="table-title">Transação</th>
                          <th className="table-title">Beneficiário</th>
                          <th className="table-title">Valor</th>
                          <th className="table-title">Imprimir</th>
                        </tr>
                      )}
                    </thead>
                  </table>
                  <div className="overflow-y-auto height-table">
                    <table className="w-full border-collapse">
                      <tbody>
                        {!loading &&
                          items.map((item) => {
                            return (
                              <tr key={item.id}>
                                <td className="table-text">
                                  {dateFormatDaily(item.created_at)}
                                </td>
                                <td className="table-text">
                                  {item.description === 'Retirada'
                                    ? 'Estornado'
                                    : item.direction === 'in'
                                    ? 'Crédito'
                                    : 'Débito'}
                                </td>
                                <td className="table-text">
                                  {item.GraphicAccount &&
                                  item.GraphicAccount?.name ? (
                                    <>
                                      <span className="extract-graphic-account">
                                        Control Account -{' '}
                                        {item.GraphicAccount.name}
                                      </span>
                                    </>
                                  ) : (
                                    <span className="extract-graphic-account">
                                      {item.user?.name}
                                    </span>
                                  )}
                                  <br />
                                  <span
                                    style={{
                                      color:
                                        item.direction === 'in' &&
                                        item.type !== 'internal'
                                          ? 'var(--green)'
                                          : 'black',
                                    }}
                                  >
                                    {item.type === 'pix' &&
                                    item.direction === 'in'
                                      ? 'Pix recebido de:'
                                      : item.type === 'pix' &&
                                        item.direction === 'out'
                                      ? 'Pix enviado para:'
                                      : item.type === 'internal' &&
                                        item.direction === 'in'
                                      ? 'Recebido via: '
                                      : item.type === 'internal' &&
                                        item.direction === 'out'
                                      ? 'Retirado via:'
                                      : /* @ts-ignore */
                                      item?.response?.message ===
                                        'Prezado cliente, a partir do horário vigente as transferências podem ser processadas até o próximo dia útil. Se preferir você pode agendá-la ou utilizar o PIX via APP!'
                                      ? 'Valor estornado fora do horário autorizado.'
                                      : 'Saldo Recebido'}{' '}
                                  </span>{' '}
                                  <br />
                                  {item.description}
                                </td>
                                <td className="table-text">
                                  {' '}
                                  {item.direction === 'in'
                                    ? item.data.user.name
                                    : item.payer_bank_name}
                                </td>

                                <td className="table-text">
                                  <span
                                    style={{
                                      color:
                                        item.direction === 'in'
                                          ? 'var(--green)'
                                          : 'var(--red)',
                                      marginLeft: '8px',
                                    }}
                                  >
                                    {item.direction === 'in' ? '+' : '-'}
                                    {currencyFormat(item.amount)}
                                  </span>

                                  <span
                                    style={{
                                      marginLeft: '20px',
                                      display:
                                        item.direction === 'in'
                                          ? 'none'
                                          : 'inline',
                                    }}
                                  ></span>
                                </td>

                                <td className="table-text">
                                  <PrintButtonIcon>
                                    <PrinterIcon
                                      onClick={() => printPDF(item)}
                                      color="var(--boxText)"
                                      className="status-icon"
                                    />
                                  </PrintButtonIcon>
                                </td>
                              </tr>
                            )
                          })}
                      </tbody>
                    </table>
                  </div>
                </TableWrapper>
              </div>
            )}
          </ContentWrapper>
          <PaginationWrapper className="max-w-[16%] w-full">
            <ArrowPageLeftIcon
              className="status-icon"
              onClick={handlePrevious}
            />
            <span className="p-texte">Página {currentPage} </span>
            <ArrowPageRightIcon className="status-icon" onClick={handleNext} />
          </PaginationWrapper>
        </Content>

        <ModalRoot open={isOpen} setIsOpen={() => setIsOpen(false)}>
          <ModalContainer>
            <ModalContent>
              <ModalClose />
              <SelectValueStatic />
            </ModalContent>
          </ModalContainer>
        </ModalRoot>
      </Container>
    </>
  )
}
